// LabelTypeExportSelector
import React, { useState, useEffect } from 'react';
import { useSetup } from '../context/SetupContext';

const style = {
    modalBody: { height: '70vh'},
    modalDescription: { textAlign: 'left'},
    tableContainer: { overflowY: 'auto', marginTop: '20px', paddingRight: '10px', boxSizing: 'border-box', height: '65vh' },
    modalFooter: { display: 'flex', justifyContent: 'flex-end', gap: '10px', height: '60px', alignItems: 'center', position: 'initial', bottom: 0, width: '100%' }
};

const LabelTypeExportSelectorModal = ({ onClose, onConfirm }) => {
    const { labels, labelTypes } = useSetup();
    const [selectedAllLabelTypes, setSelectedAllLabelTypes] = useState(false);
    const [selectedLabelTypes, setSelectedLabelTypes] = useState([]);

    useEffect(() => {
        if (selectedAllLabelTypes) setSelectedLabelTypes(Object.keys(labelTypes));
        else setSelectedLabelTypes([]);
    }, [labelTypes,selectedAllLabelTypes, setSelectedLabelTypes]);

    const handleCloseModal = () => {
        setSelectedAllLabelTypes(false);
        setSelectedLabelTypes([]);
        onClose();
    }

    const handleConfirmModal = () => {
        onConfirm(selectedLabelTypes);
        handleCloseModal();
    }
    
    const handleSelectLabelType = (labelType) => {
        setSelectedLabelTypes(
            (prev) => prev.includes(labelType) ? 
                prev.filter((lt) => lt !== labelType) 
                : [...prev, labelType]
        );
    }

    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <div className="modal-header">
                    <h3>Select to Export</h3>
                    <button className="close-button" onClick={() => handleCloseModal()}>&times;</button>
                </div>
                <div className="modal-body" style={style.modalBody}>
                    <p style={style.modalDescription}>Select label types to add to the verbatims TXT export</p>
                    <div style={style.tableContainer}>
                        <table className="loadexportmodal-table">
                            <thead>
                                <tr>
                                    <th>
                                        <input type="checkbox" checked={selectedAllLabelTypes} onChange={() => setSelectedAllLabelTypes(!selectedAllLabelTypes)} />
                                    </th>
                                    <th colSpan="2">Label Type</th>
                                    <th>Labels Review</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(labelTypes).map((labelType) => (
                                    <tr key={labelType}>
                                        <td>
                                            <input type="checkbox" checked={selectedLabelTypes.includes(labelType)} onChange={() => handleSelectLabelType(labelType)} />
                                        </td>
                                        <td colSpan="2">{labelType}</td>
                                        {labels[labelType] && labels[labelType].length > 0 ? (
                                            <td>{labels[labelType].map(label => label.name).join(", ")}</td>) 
                                            : (<td></td>)
                                        }
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="modal-footer" style={style.modalFooter}>
                    <button className="secondary-button" onClick={() => handleCloseModal()}>Close</button>
                    <button className="primary-button" onClick={() => handleConfirmModal()}>Export</button>
                </div>
            </div>
        </div>
    );
};

export default LabelTypeExportSelectorModal;
